import { AppProps } from './types';

type TrackingContextProps = Pick<
    AppProps,
    'user' | 'env' | 'event' | 'settings' | 'request'
> & {
    components?: Partial<AppProps['components']>;
};

export function getTrackingContextFrom(props: TrackingContextProps) {
    return {
        userId: props.user?.id || 0,
        locale: props.env?.localeInfo?.locale || '',
        event: {
            id: props.event?.id || '',
            isOnline: props.event?.isOnlineEvent || false,
            localityPlaceId:
                props.components?.eventDetails?.location?.localityPlaceId,
        },
        guestId: props.user?.guestId || '',
        sessionId: props.request?.session_id || '',
    };
}
